import React from 'react';
import {HtmlDisplay} from "../Display";
import {HelpText} from "./HelpText";
import {helpTextSuffix} from "./inputConstants";

interface FileUploadButtonProps {
    accept?: string;
    disabled?: boolean;
    helpText?: string;

    isCollapsed?: boolean;
    label: string;
    name: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FileUploadButton: React.FC<FileUploadButtonProps> = ({accept, disabled, helpText, isCollapsed, label, name, onChange}: FileUploadButtonProps) => {

    return (
        <>
            <input type="file"
                   accept={accept}
                   aria-describedby={`${name}${helpTextSuffix}`}
                   data-testid={name}
                   name={name}
                   id={name}
                   onChange={onChange}
            />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor={name}
                   className={`button ${!isCollapsed ? "expanded" : ""} ${disabled ? " is-disabled" : ""}`}>
                <HtmlDisplay html={label} isInline/>
            </label>
            <HelpText name={name} helpText={helpText} isCentered/>
        </>
    );
};
